export const BASIC_DETAILS_LABELS = {
    HEADING: 'Basic Details',
    PAN: 'PAN',
    CIN: 'CIN',
    LLPIN: 'LLPIN',
    GST: 'GST',
    ADDRESS: 'Address',
} as const;
